module.exports = __webpack_public_path__ + "img/18.5fb3fbce.jpg";